import { createApp, App as VueApp } from 'vue';
import { configure as configureGtag } from 'vue-gtag';
import server from '@/serverProxy';
import globalActions from '@/globalActions';
import sl from '@/serviceLocator';
import store from '@/ts-store';
import _ from 'lodash';
import { onIdTokenChanged } from 'firebase/auth';
import { handleIdTokenChange } from '@/authSession';
import App from './App.vue';
import router from './router';
import './styles/base.css';
import vuetify from './plugins/vuetify';
import loadBases from './loadBases';
import i18n from './i18n';
import { auth } from './firebase';
import 'vue-inner-image-zoom/lib/styles.min.css';

sl.set('serverProxy', server);
sl.set('globalActions', globalActions);
sl.set('store', store);
sl.set('lodash', _);
sl.set('router', router);

if (import.meta.env.MODE === 'production') {
  configureGtag({
    tagId: import.meta.env.VUE_APP_GOOGLE_ANALYTICS_KEY,
    gtagName: 'googleAnalytics',
    pageTracker: { router },
  });
}

let app: VueApp | undefined;

// Fires on sign-in, sign-out and every token rotation; see authSession.ts.
// The request interceptor in axiosInstance.ts reads the token itself.
onIdTokenChanged(auth, async user => {
  try {
    await handleIdTokenChange(user);
  } catch {
    // Mount the app regardless; it renders signed out or with partial data.
  }
  // Mount only once the first auth state is known, so the initial render
  // already has the user and their permissions.
  if (!app) {
    app = createApp(App);
    app.use(router);
    app.use(vuetify);
    app.use(i18n);
    loadBases(app);
    app.mount('#app');
  }
});
